import { ErrorCodeApi } from '../constants';
import { ConvertEnumKeysToLocale } from '../types';

/**
 * Converts the keys of an enumerated type to a localized string format.
 *
 * @template T - The type of the enum key, defaults to the keys of the `ErrorCodeApi` enum.
 * @param {T} key - The enum key to be converted. Can be of type `string` or `T`.
 * @returns {string | T} - Returns a string with periods replaced by dashes if the key is a string,
 *                         otherwise returns the original key.
 *
 * @example
 * // Given an enum ErrorCodeApi { 'error.code.example' = 1 }
 * convertEnumKeysToLocale('error.code.example'); // Returns 'error-code-example'
 */
export const convertEnumKeysToLocale = <T extends string = keyof typeof ErrorCodeApi>(
  key: T,
): ConvertEnumKeysToLocale<T> => {
  if (typeof key === 'string') {
    return `${key as T}`.replace(/\./g, '-') as ConvertEnumKeysToLocale<T>;
  }
  return key;
};
